/** Shared phone formatting for portal display and data entry. */

export function phoneDigits(value) {
  let digits = String(value || '').replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) {
    digits = digits.slice(1);
  }
  return digits;
}

/**
 * Format stored numbers as (555) 123-4567 only when they are a complete
 * 10-digit US number. Seven-digit locals, extensions, and other country
 * codes keep their original stored text.
 */
export function formatPhoneForDisplay(value) {
  const raw = String(value || '').trim();
  if (!raw) {
    return '';
  }
  const digits = phoneDigits(raw);
  if (digits.length !== 10) {
    return raw;
  }
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

/**
 * Progressive (555) 123-4567 formatting while the user types a US number.
 */
export function formatPhoneWhileTyping(value) {
  const digits = phoneDigits(value).slice(0, 10);
  if (!digits) {
    return '';
  }
  if (digits.length <= 3) {
    return digits;
  }
  if (digits.length <= 6) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  }
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}
